// XP gem consolidation helpers (pure, deterministic). Owner 2026-11-03: 'XP gems should consolidate into larger gems when
// there are too many'. Kind follows value so a merged pile LOOKS bigger (kind 2 at HUGE_XP_VALUE or more is drawn as the red
// Huge gem by render/gemTier.ts, which restates the same number).
export const XP_MEDIUM_AT = 3, XP_LARGE_AT = 10, HUGE_XP_VALUE = 40;
/** soft gem count above which the periodic merge pass runs */
export const GEM_MERGE_AT = 300;
/** the merge pass runs every this many ticks (0.5 s) */
export const GEM_MERGE_EVERY = 30;
/** merge grid cell size (m) and the least gems in a cell for it to merge */
export const GEM_MERGE_CELL = 2.5, GEM_MERGE_MIN = 3;

/** XP gem kind (0 small, 1 medium, 2 large) for a value; same thresholds as a kill's drop */
export function xpKindFor(value: number): number {
  return value >= XP_LARGE_AT ? 2 : value >= XP_MEDIUM_AT ? 1 : 0;
}

interface MergeGem { alive: boolean; x: number; y: number; z: number; value: number; kind: number; pull: boolean }

/** Folds close, unpulled XP gems (kinds 0-2) into one gem per crowded grid cell. Returns how many gems were removed.
 *  Total XP is conserved exactly; iteration is in array order (deterministic, no Rng). */
export function mergeXpGems(gems: MergeGem[], specialFrom: number): number {
  const cells = new Map<number, number[]>();
  let count = 0;
  for (let i = 0; i < gems.length; i++) {
    const g = gems[i];
    if (!g.alive || g.pull || g.kind >= specialFrom) continue;
    count++;
    const key = (Math.floor(g.x / GEM_MERGE_CELL) + 512) * 1024 + (Math.floor(g.z / GEM_MERGE_CELL) + 512);
    const l = cells.get(key);
    if (l) l.push(i); else cells.set(key, [i]);
  }
  if (count === 0) return 0;
  let removed = 0;
  for (const idx of cells.values()) {
    if (idx.length < GEM_MERGE_MIN) continue;
    let sum = 0, cx = 0, cz = 0;
    for (const i of idx) { const g = gems[i]; sum += g.value; cx += g.x * g.value; cz += g.z * g.value; }
    if (sum > 0) { cx /= sum; cz /= sum; } else { cx = gems[idx[0]].x; cz = gems[idx[0]].z; }
    let best = idx[0], bd = Infinity;
    for (const i of idx) { const g = gems[i]; const d = (g.x - cx) ** 2 + (g.z - cz) ** 2; if (d < bd) { bd = d; best = i; } }
    const keep = gems[best];
    keep.value = sum;
    keep.kind = Math.max(keep.kind, xpKindFor(sum));
    for (const i of idx) if (i !== best) { gems[i].alive = false; removed++; }
  }
  return removed;
}
